import React from 'react';
import fastTrack from '../assets/FastTrack.jpg';
import timetoflex from '../assets/timetoflex.jpg';
import cardGraphix from '../assets/CardGraphix.jpg';
import budgetTracker from '../assets/BudgetTracker.jpg';
import fitnessTracker from '../assets/FitnessTracker.jpg';
import quizChallenge from '../assets/QuizChallenge.jpg'

export default function Projects() {
    return (
        <div className="container ">
            <h1>My Projects</h1>

            <div className="prj-container ">

                <div className="projects" >
                    <small className="prj-name">FastTrack</small>
                    <a href="https://fasttrackpenn.herokuapp.com/">
                        <img className="project-img block1" src={fastTrack} alt="fastrack" />
                        <p className="prj-description">Developed to target users who fast and want to keep track of their fasting schedules or find new ones.</p>
                    </a>
                </div>

                <div className="projects" >
                    <small className="prj-name">Time To Flex</small>
                    <a href="https://appetize.io/app/b_ad7pqnulfdrrausqqy6wt4ki34?device=iphone14pro&osVersion=26.0&toolbar=true">
                        <img className="project-img block1" src={timetoflex} alt="timetoflex" />
                        <p className="prj-description">Time To Flex is a simple iOS timer app that tracks workout sets and rest periods to keep users focused and consistent.</p>
                    </a>
                </div>

                <div className="projects" >
                    <small className="prj-name">CardGraphix</small>
                    <a href="https://card-graphix.web.app/">
                        <img className="project-img block2 " src={cardGraphix} alt="cardgraphix" />
                        <p className="prj-description">A Website where users can create their own business card designs free of charge and export it to PDF for printing</p>
                    </a>
                </div>

                <div className="projects" >
                    <small className="prj-name">BudgetTracker</small>
                    <a href="https://powerful-plains-32252.herokuapp.com">
                        <img className="project-img block2" src={budgetTracker} alt="budgettracker" />
                        <p className="prj-description">A Website where you can track your spendings and earnings by inputting them.</p>
                    </a>
                </div>

                <div className="projects" >
                    <small className="prj-name">FitnessTracker</small>
                    <a href="https://workout-tracker-project.onrender.com/?id=68e6f1c826e86b004312940d">
                        <img className="project-img block2" src={fitnessTracker} alt="fitnesstracker" />
                        <p className="prj-description">A Web Page where users are able to create, save, and continue workouts.</p>
                    </a>
                </div>

                <div className="projects" >
                    <small className="prj-name">QuizChallenge</small>
                    <a href="https://taliitacamargo.github.io/quiz-project/">
                        <img className="project-img block2" src={quizChallenge} alt="quizchallenge" />
                        <p className="prj-description">An application where users can play a quiz challenge about Javascript.</p></a>
                </div>
            </div>

        </div>
    );
}
